const fileExplorer = {
  toolbar: {
    gridView: 'Grid view',
    listView: 'List view',
    searchPlaceholder: 'Search files...',
    searchAriaLabel: 'Search files',
    upload: 'Upload',
    uploadAriaLabel: 'Upload files',
    newFolder: 'New Folder',
    newFolderAriaLabel: 'Create new folder',
    setAsTemplate: 'Set as Template',
    setAsTemplateAriaLabel: 'Set selected file as template',
    done: 'Done',
    select: 'Select',
    exitSelectionAriaLabel: 'Exit selection mode',
    enterSelectionAriaLabel: 'Enter selection mode',
    viewModeAriaLabel: 'View mode',
  },
  empty: {
    noFiles: 'No files found',
    noFilesInFolder: 'This folder is empty',
    noSearchResults: 'No files match your search',
    searchResultsHint: 'Try adjusting your search terms',
    dragDropHint: 'Drag and drop files here to upload',
  },
  fileList: {
    headers: {
      name: 'Name',
      modified: 'Modified',
      size: 'Size',
      type: 'Type',
    },
  },
  tree: {
    root: 'Files',
  },
  errorLoading: 'Error loading files',
};

const fileActions = {
  upload: 'Upload',
  newFolder: 'New Folder',
  rename: 'Rename',
  move: 'Move',
  moveTo: 'Move to...',
  share: 'Share',
  download: 'Download',
  delete: 'Delete',
  open: 'Open',
  select: 'Select',
  setAsTemplate: 'Set as Template',
  downloadingFile: 'Downloading {name}',
  failedToDownload: 'Failed to download file',
};

const bulkActions = {
  itemSelected: '{count} item selected',
  itemsSelected: '{count} items selected',
  deselectAll: 'Deselect All',
  selectAll: 'Select All',
  download: 'Download',
  moveTo: 'Move to...',
  delete: 'Delete',
  downloadingFile: 'Downloading file',
  downloadingArchive: 'Downloading {count} files as {name}',
  failedToDownload: 'Failed to download: {error}',
  clearSelectionAriaLabel: 'Clear selection',
  bulkFileActionsAriaLabel: 'Bulk file actions',
};

const templateDialog = {
  title: 'Set Document as Template',
  settingAs: 'Setting {name} as a template',
  documentType: 'Document Type',
  selectDocumentType: 'Select a document type',
  cancel: 'Cancel',
  setAsTemplate: 'Set as Template',
  successUpdated: 'Template setting updated successfully',
  failedToUpdate: 'Failed to update template setting',
};

const dialogs = {
  upload: {
    title: 'Upload Files',
    dropzone: 'Drag and drop files here or click to browse',
    filesToUpload: 'Files to upload',
    uploading: 'Uploading...',
    upload: 'Upload',
    uploadComplete: 'Upload complete',
    uploadFailed: 'Upload failed',
    errorFailed: 'Failed to upload {filename}',
    statusFailed: 'Failed',
    cancel: 'Cancel',
  },
  createFolder: {
    title: 'Create New Folder',
    label: 'Folder Name',
    placeholder: 'Enter folder name',
    create: 'Create Folder',
    cancel: 'Cancel',
    errorNoName: 'Please enter a folder name',
    successCreated: 'Folder "{name}" created successfully',
    errorFailed: 'Failed to create folder',
  },
  rename: {
    title: 'Rename',
    titleFile: 'Rename File',
    titleFolder: 'Rename Folder',
    label: 'New Name',
    placeholder: 'Enter new name',
    save: 'Rename',
    cancel: 'Cancel',
    errorNoName: 'Please enter a file name',
    errorNoFile: 'No file selected',
    successRenamed: 'Renamed to "{name}"',
    errorFailed: 'Failed to rename file: {error}',
  },
  move: {
    title: 'Move',
    titleFile: 'Move File',
    titleFolder: 'Move Folder',
    moving: 'Moving: "{name}"',
    selectDestination: 'Select destination folder',
    labelDestination: 'Destination Folder',
    optionRoot: 'Root Folder',
    move: 'Move',
    cancel: 'Cancel',
    errorNoFile: 'No file selected',
    successMoved: 'Moved "{name}" to {destination}',
    errorFailed: 'Failed to move file: {error}',
  },
  delete: {
    title: 'Delete',
    titleFile: 'Delete File',
    titleFolder: 'Delete Folder',
    message: 'Are you sure you want to delete "{name}"?',
    warningFolder:
      'Warning: This will also delete all files and folders inside it.',
    warningPermanent: 'This action cannot be undone.',
    confirm: 'Delete',
    cancel: 'Cancel',
    errorNoFile: 'No file selected',
    successDeleted: '"{name}" deleted successfully',
    errorFailed: 'Failed to delete: {error}',
  },
  bulkDelete: {
    title: 'Delete {count} Item',
    titlePlural: 'Delete {count} Items',
    message: 'Are you sure you want to delete the following items?',
    fileCount: '{count} file',
    fileCountPlural: '{count} files',
    folderCount: '{count} folder',
    folderCountPlural: '{count} folders',
    warningFolders:
      '⚠️ Warning: Deleting folders will permanently delete all their contents.',
    warningPermanent: 'This action cannot be undone.',
    confirm: 'Delete',
    cancel: 'Cancel',
    successDeleted: 'Deleted {count} item',
    successDeletedPlural: 'Deleted {count} items',
    errorFailed: 'Failed to delete {count} item',
    errorFailedPlural: 'Failed to delete {count} items',
    errorGeneral: 'Failed to delete files: {error}',
  },
  bulkMove: {
    title: 'Move {count} Item',
    titlePlural: 'Move {count} Items',
    moving: 'Moving {count} item:',
    movingPlural: 'Moving {count} items:',
    fileCount: '{count} file',
    fileCountPlural: '{count} files',
    folderCount: '{count} folder',
    folderCountPlural: '{count} folders',
    labelDestination: 'Destination Folder',
    optionRoot: 'Root Folder',
    move: 'Move',
    cancel: 'Cancel',
    errorNoFiles: 'No files selected',
    successMoved: 'Moved {count} item to {destination}',
    successMovedPlural: 'Moved {count} items to {destination}',
    errorFailed: 'Failed to move {count} item',
    errorFailedPlural: 'Failed to move {count} items',
    errorGeneral: 'Failed to move files: {error}',
  },
};

export const en = {
  fileExplorer,
  fileActions,
  bulkActions,
  templateDialog,
  dialogs,
};
